import * as React from "react";
const SvgFiRrStarSharpHalfStroke = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-sharp-half-stroke_svg__a)">
      <path
        fill="#062147"
        d="M23.836 8.599c-.338-1.025-1.344-2.222-3.067-2.222H16.4l-1.327-4.138C14.543.586 13.087 0 12 0S9.459.587 8.929 2.24L7.602 6.377H3.23C1.498 6.377.496 7.576.167 8.596c-.34 1.028-.24 2.591 1.16 3.612l3.56 2.603-1.351 4.184c-.535 1.652.302 2.978 1.18 3.608.487.352 1.17.625 1.919.625a3.12 3.12 0 0 0 1.882-.641L12 20.027l3.48 2.559c1.14.837 2.715.81 3.793.024.885-.632 1.727-1.958 1.19-3.615l-1.352-4.184 3.56-2.602c1.395-1.017 1.499-2.578 1.164-3.61m-2.343 1.995-4.145 3.029a1 1 0 0 0-.361 1.115l1.574 4.873c.263.812-.33 1.285-.458 1.377a1.21 1.21 0 0 1-1.438-.013L12.59 17.98a1 1 0 0 0-.592-.194V2c.27 0 .922.083 1.169.851l1.55 4.832a1 1 0 0 0 .952.694h5.098c.802 0 1.083.593 1.166.844.083.255.206.9-.441 1.373"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-sharp-half-stroke_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarSharpHalfStroke;
